import React, { useEffect, useRef } from 'react';

import Input from 'components/Inputs/Input';

export interface SingleVerificationCodeProps {
  value: string;
  inputClassName?: string;
  type?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
  focus?: boolean;
  onPaste: (event: React.ClipboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  onBlur?: () => void;
}

const SingleVerificationInput = ({
  value,
  type,
  inputClassName,
  onChange,
  onKeyDown,
  onFocus,
  focus,
  onPaste,
  disabled,
}: SingleVerificationCodeProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const { current } = inputRef;

    if (!current) {
      return;
    }

    if (focus) {
      current.focus();
    }
  });

  return (
    <Input
      inputClassName={inputClassName}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
      onPaste={onPaste}
      inputRef={inputRef}
      disabled={disabled}
      type={type}
    />
  );
};

export default SingleVerificationInput;
